import { useCallback } from 'react';
import { notify } from 'js/actions/alert-actions';
import { useDispatch } from 'react-redux';

export function useNotify() {
  const dispatch = useDispatch();
  return useCallback((alert) => dispatch(notify(alert)), [dispatch]);
}
